import { cn } from "@/helpers";

interface AssessmentStepIconProps {
  step_id: string;
  active: boolean;
  competency_id: string;
  checked: boolean;
  addFn: (e: React.MouseEvent<HTMLButtonElement>) => void;
  removeFn: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function AssessmentStepIcon({
  step_id,
  active,
  competency_id,
  checked,
  addFn,
  removeFn,
}: AssessmentStepIconProps) {
  const wrapperclass = cn("flex items-center justify-center", "h-[3rem]", "text-gray-700");

  return (
    <div className={wrapperclass}>
      {checked ? (
        active ? (
          <button
            type="button"
            className="material-symbols-rounded cursor-pointer text-3xl text-green-600"
            title="Click to remove"
            aria-label="Remove from process step"
            data-competency-id={competency_id}
            data-process-step-id={step_id}
            onClick={removeFn}
          >
            check_circle
          </button>
        ) : (
          <span className="material-symbols-rounded text-3xl text-green-600">check_circle</span>
        )
      ) : active ? (
        <button
          type="button"
          className="material-symbols-rounded cursor-pointer text-3xl hover:text-almost-white"
          title="Add to process step"
          aria-label="Add to process step"
          data-competency-id={competency_id}
          data-process-step-id={step_id}
          onClick={addFn}
        >
          add
        </button>
      ) : null}
    </div>
  );
}
